import Fetch from 'utils/fetch';

export const obterTodosFornecedoresEmMaterial = async id => {
  const request = await Fetch.post(`/fornecedor/obterTodosFornecedoresEmMaterial/${id}`);
  return request.data;
}